// extracted by mini-css-extract-plugin
export var autoExpand = "_2t-8";
export var container = "_2t-7";
export var containerWidth = "_2t-5";
export var disabled = "_2t-2";
export var error = "_2t-3";
export var fullWidth = "_2t-6";
export var inputWrapper = "_2t-0";
export var small = "_2t-1";
export var textarea = "_2t-4";